import DOMPurify from "dompurify"
import EasyMDE from "easymde"
import { marked } from "marked"
import "easymde/dist/easymde.min.css"

marked.setOptions({
  breaks: true,
  gfm: true
})

const renderMarkdown = (markdown) => DOMPurify.sanitize(marked.parse(markdown || ""))

const mountMarkdownEditors = () => {
  document.querySelectorAll("[data-markdown-editor]").forEach((element) => {
    if (element.dataset.markdownEditorMounted === "true") return

    element.dataset.markdownEditorMounted = "true"
    new EasyMDE({
      element,
      spellChecker: false,
      status: false,
      minHeight: "420px",
      previewRender: (plainText) => renderMarkdown(plainText),
      toolbar: [
        "bold",
        "italic",
        "heading",
        "|",
        "quote",
        "unordered-list",
        "ordered-list",
        "|",
        "link",
        "image",
        "table",
        "horizontal-rule",
        "|",
        "preview",
        "side-by-side",
        "fullscreen",
        "|",
        "guide"
      ]
    })
  })
}

const mountMarkdownRenders = () => {
  document.querySelectorAll("[data-markdown-render]").forEach((container) => {
    const source = container.querySelector("[data-markdown-source]")
    if (!source) return

    const markdown = source.content?.textContent || source.textContent || source.innerHTML || ""
    container.innerHTML = renderMarkdown(markdown)
  })
}

export const mountMarkdownContent = () => {
  mountMarkdownEditors()
  mountMarkdownRenders()
}
